export const sendMessage = async ({
  conversationId,
  message,
}: {
  conversationId: string;
  message: string;
}) => {
  const response = await fetch("https://api.pwyll.io/messages/sendMessage", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      conversationId: conversationId,
      message: message,
    }),
  });
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};

export const newConversation = async ({
  llmModelId,
  username,
}: {
  llmModelId: string;
  username: string;
}) => {
  const response = await fetch(
    "https://api.pwyll.io/messages/newConversation",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        llmModelId: llmModelId,
        username: username,
      }),
    },
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};
